export const ENV = 'preprod'; // 'local', 'codeins';